export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    title: that.$l('package_label_materialName') || '包装中文名',
    field: 'materialName',
    minWidth: 150,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('package_label_materialNameEn') || '包装英文名',
    field: 'materialNameEn',
    minWidth: 150,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.btn_choice') || '选择',
    field: 'col-opt',
    align: 'center',
    width: 80,
    fixed: 'right',
    slots: {
      default: 'opt'
    }
  }
]
